var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-banner-container',{attrs:{"header":"Preferences","md":"5"}},[_c('personal-preferences',{ref:"preferences"}),_c('div',{staticClass:"d-flex justify-center"},[_c('j-btn',{staticClass:"mt-4",attrs:{"wide":""},on:{"click":function($event){return _vm.$refs.preferences.save()}}},[_vm._v("Save")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }